import { setHas } from '@/types/typeUtils'

type SponsorTierValueType = number | null

export const SPONSOR_TIER = {
  GLOBAL: 1,
  REGIONAL: 2,
  LOCAL: 3,
  CAPPED_GLOBAL: 101,
  CAPPED_REGIONAL: 102,
  CAPPED_LOCAL: 103,
  PAUSED_GLOBAL: 201,
  PAUSED_REGIONAL: 202,
  PAUSED_LOCAL: 203,
  DAILY_CAPPED_GLOBAL: 301,
  DAILY_CAPPED_REGIONAL: 302,
  DAILY_CAPPED_LOCAL: 303,
  NOT_A_SPONSOR: 1000,
  LEGACY_NOT_A_SPONSOR: 0,
  LEGACY_NOT_A_SPONSOR_NULL: null
} as const satisfies Record<string, SponsorTierValueType>

const SPONSOR_VALUES = new Set([SPONSOR_TIER.GLOBAL, SPONSOR_TIER.REGIONAL])
const PPV_VALUES = new Set([
  SPONSOR_TIER.GLOBAL,
  SPONSOR_TIER.REGIONAL,
  SPONSOR_TIER.LOCAL
])
const CAPPED_VALUES = new Set([
  SPONSOR_TIER.CAPPED_GLOBAL,
  SPONSOR_TIER.CAPPED_REGIONAL,
  SPONSOR_TIER.CAPPED_LOCAL,
  SPONSOR_TIER.DAILY_CAPPED_GLOBAL,
  SPONSOR_TIER.DAILY_CAPPED_REGIONAL,
  SPONSOR_TIER.DAILY_CAPPED_LOCAL
])
const PAUSED_VALUES = new Set([
  SPONSOR_TIER.PAUSED_GLOBAL,
  SPONSOR_TIER.PAUSED_REGIONAL,
  SPONSOR_TIER.PAUSED_LOCAL
])

const isSponsor = (sponsorTier: SponsorTierValueType): boolean =>
  setHas(SPONSOR_VALUES, sponsorTier)

const isPPV = (sponsorTier: SponsorTierValueType): boolean =>
  setHas(PPV_VALUES, sponsorTier)

const isCapped = (sponsorTier: SponsorTierValueType): boolean => {
  if (!sponsorTier) return false
  return setHas(CAPPED_VALUES, sponsorTier)
}

const isPaused = (sponsorTier: SponsorTierValueType): boolean => {
  if (!sponsorTier) return false
  return setHas(PAUSED_VALUES, sponsorTier)
}

export const SponsorTierModule = {
  isSponsor,
  isPPV,
  isCapped,
  isPaused
} as const
